import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'

import { useAppSelector } from '@/store'
import { setEnamelRecipeOutput, setEnamelTypeByRegion } from '@/store/pfmCrown'

import EnamelTooltip from './components/EnamelTooltip'

const KonvaPFMEnamel = () => {
  const dispatch = useDispatch()
  const enamel = useAppSelector((state) => state.pfmCrown.enamelPosition)
  const enamelRecipe = useAppSelector((state) => state.pfmCrown.enamelRecipe)

  const canvasImage = useAppSelector((state) => state.app.canvasImage)

  const [tooltipOpenMap, setTooltipOpenMap] = useState<Record<string, boolean>>(
    {},
  )

  useEffect(() => {
    const initialTooltipState: Record<string, boolean> = {}
    Object.keys(enamel?.[canvasImage?.id] || {}).forEach((key) => {
      initialTooltipState[key] = true
    })
    setTooltipOpenMap(initialTooltipState)
  }, [enamel, canvasImage?.id])

  const handleToggleTooltip = useCallback((key: string) => {
    setTooltipOpenMap((prev) => ({ ...prev, [key]: !prev[key] }))
  }, [])

  const handleCloseTooltip = useCallback((key: string) => {
    setTooltipOpenMap((prev) => ({ ...prev, [key]: false }))
  }, [])

  const handleDeleteEnamelKey = useCallback(
    (regionKey: string) => {
      if (!canvasImage?.id) return

      dispatch(
        setEnamelRecipeOutput({
          imageId: canvasImage?.id,
          key: regionKey,
          result: undefined,
        }),
      )
      dispatch(
        setEnamelTypeByRegion({
          region: regionKey,
          value: '',
        }),
      )
    },
    [dispatch, canvasImage?.id],
  )
  return (
    <>
      {Object.keys(enamel?.[canvasImage?.id] || {}).map((key) => {
        const data = enamel?.[canvasImage?.id]?.[key]
        const output = enamelRecipe?.[canvasImage?.id]?.[key]
        if (!data?.output || !output) return null
        return (
          <EnamelTooltip
            key={key}
            keyName={key}
            data={data}
            output={output}
            open={!!tooltipOpenMap[key]}
            toggle={handleToggleTooltip}
            close={handleCloseTooltip}
            onDelete={handleDeleteEnamelKey}
          />
        )
      })}
    </>
  )
}

export default KonvaPFMEnamel
